var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeUserAltPrimary = function SvgIconAwesomeUserAltPrimary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.704,
    height: 43.704,
    viewBox: "0 0 43.704 43.704",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M21.852,24.583A12.292,12.292,0,1,0,9.56,12.292,12.295,12.295,0,0,0,21.852,24.583Zm10.926,2.731h-4.7a14.859,14.859,0,0,1-12.445,0h-4.7A10.925,10.925,0,0,0,0,38.241v1.366a4.1,4.1,0,0,0,4.1,4.1H39.606a4.1,4.1,0,0,0,4.1-4.1V38.241A10.925,10.925,0,0,0,32.778,27.315Z",
    fill: "#36b3a8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeUserAltPrimary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-awesome-user-alt-primary.7d7343432a3aff987c03888a02159d7b.svg";